import React, { Component } from "react";
import LicensesForm from "../LicensesForm/LicensesForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ReportedPage
Description : Componente que contienen el formulario de la pantalla Reported 
Date Autor Modification
================================================================================
26/10/2021 Santiago Coca Rojas Creación – Se llama al componente ReportedForm
================================================================================ */
class LicensesPage extends Component{
    render(){
        return(
            <div>                    
                <LicensesForm/>
            </div>
        )   
    }
}

export default LicensesPage;